var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconMapGpsZjh4Kfswtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6fabe6;}.cls-2{fill:#9dcc6b;}.cls-3{fill:#fc6;}.cls-4{fill:#ffde76;}.cls-5{fill:#b5e08c;}.cls-6{fill:#82bcf4;}.cls-7{fill:#db5669;}.cls-8{fill:#f26674;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Map GPS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Map_GPS",
    "data-name": "Map GPS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,47H4.16a2,2,0,0,1-2-2.16L3.11,33H17C21,47.08,20.23,44.28,21,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,9V27H3.58L4.85,10.84A2,2,0,0,1,6.85,9H8c0,4.42,8,14,8,14s8-9.58,8-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.42,27H34V9h7.15a2,2,0,0,1,2,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.84,45a2,2,0,0,1-2,2H27L23,33H44.89C46.13,48.64,45.84,44.05,45.84,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,47H4.16a2,2,0,0,1-2-2.16L3.11,33H17C21,47.08,20.23,44.28,21,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,9V27H3.58L4.85,10.84A2,2,0,0,1,6.85,9H8c0,4.42,8,14,8,14s8-9.58,8-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.42,27H34V9h7.15a2,2,0,0,1,2,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.84,45a2,2,0,0,1-2,2H27L23,33H44.89C46.13,48.64,45.84,44.05,45.84,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27,47H21L17,33H3.11l.47-6H28V9h6V27H44.42l.47,6H23C27,47.08,26.23,44.28,27,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23,33l3.43,12h-6L17,33H6c.2-2.52.1-1.19.47-6H28V9h6V27H44.42l.47,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28,9V27H6.42c.21-2.65,0-.38,1.06-13.48A64.84,64.84,0,0,0,14,23s.39-.47,1-1.25c.61.78,1,1.25,1,1.25s8-9.58,8-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M20.43,45H7.16a2,2,0,0,1-2-2.16L6,33H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.84,45H26.43L23,33H44.89C46.13,48.64,45.84,44.05,45.84,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.42,27H34V9h7.15a2,2,0,0,1,2,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M24,9c0,3.69-5.71,11.24-8,14,0,0-8-9.58-8-14A8,8,0,0,1,24,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24,9c0,3.07-3.87,8.64-6.22,11.74C16.52,19.19,10,11,10,7a7.87,7.87,0,0,1,1.44-4.56A8,8,0,0,1,24,9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 16,
    cy: 9,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconMapGpsZjh4Kfswtl);
export default __webpack_public_path__ + "static/media/reshot-icon-map-gps-ZJH4KFSWTL.b2429c34817e74ca60203e5b13b3423c.svg";
export { ForwardRef as ReactComponent };